export const convertDataToApi = (data: any) => {
  return {
    ...data,
    order: +data.order,
    freeLessonsCount: +data.freeLessonsCount,
  };
};
